export default "__VITE_ASSET__BN_U05aX__"